import { Box, Button, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import { Fragment, useState } from "react";

import * as yup from "yup";
import { verifyPasswordResetService } from "../../services/auth";
import BackButton from "../../components/BackButton";
const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const validationSchema = yup.object({
  mobile: yup
    .string("Enter your mobile")
    .min(5, "too short")
    .max(255, "too long")
    .test("test-name", "Enter Valid Mobile number", function (value) {
      const emailRegex =
        /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      let isValidEmail = emailRegex.test(value);
      let isValidPhone = phoneRegExp.test(value);
      if (!isValidEmail && !isValidPhone) {
        return false;
      }
      return true;
    })
    .required("Enter Valid Mobile number"),
  code: yup
    .string("Enter your mobile")
    .min(5, "too short")
    .max(6, "too long")
    .required("Please enter verification code you have received"),
});

export default function VerifyCodeStep({ onSubmit, mobile, setStep }) {
  const [loading, setLoading] = useState(false);
  const formik = useFormik({
    initialValues: {
      mobile: mobile,
      code: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const { mobile, code } = values;
      setLoading(true);

      const { error } = await verifyPasswordResetService({
        body: { mobile, code },
      });
      setLoading(false);
      if (error) {
        if (error) {
          formik.setFieldError("code", error);
          return console.error(error);
        }
      }
      onSubmit(code);
    },
  });

  const goBack = () => setStep("send_request");

  return (
    <Fragment>
      <BackButton
        primaryText="Verify"
        secondaryText="Your Number"
        goBack={goBack}
      />
      <Box width={1}>
        <Box
          display="flex"
          alignItems="flex-start"
          justifyContent="center"
          flexDirection="column"
          // sx={{ width: "99%", height: 1 }}
        >
          <Typography fontWeight="bold" sx={{ mt: 2 }}>
            Code
          </Typography>
          <Box sx={{ width: "100%", my: 2 }}>
            <TextField
              fullWidth
              id="code"
              name="code"
              // label="Verification code"
              value={formik.values.code}
              onChange={formik.handleChange}
              error={formik.touched.code && Boolean(formik.errors.code)}
              helperText={formik.touched.code && formik.errors.code}
              placeholder="123456"
              variant="standard"
              InputProps={{
                sx: { minHeight: "56px" },
                disableUnderline: true,
              }}
              sx={{
                backgroundColor: "background.paper",
                borderRadius: "8px",
                minHeight: "56px",
                display: "flex",
                alignItems: "center",
                px: 2,
              }}
            />
          </Box>
          <Typography
            textAlign="center"
            variant="body1"
            color="text.secondary"
            sx={{ mt: 3, width: 1 }}
          >
            You can find the code in your SMS
          </Typography>
        </Box>
      </Box>
      <Box width={1}>
        <Button
          fullWidth
          type="submit"
          sx={{ py: 1.5, fontWeight: "bold", mt: 6 }}
          variant="contained"
          disabled={loading}
          onClick={formik.handleSubmit}
          color="secondary"
        >
          Verify
        </Button>
      </Box>
    </Fragment>
  );
}
